import { Text } from '@chakra-ui/react'
import { DateTime } from 'luxon'

import type { SeriesConsentReminderBannerData } from '@/common/services/seriesPage/types'
import { toHumanReadableString } from '@/utils/time'

import { useServerNow } from '@/client/hooks'
import * as url from '@/client/services/url'

import useSATBootcampLearnerOnboardingState from '@/components/SATBootcamp/hooks/useSATBootcampLearnerOnboardingState/useSATBootcampLearnerOnboardingState'
import ShwLink from '@/components/ShwLink'
import Alert from '@/components/UI/Alert'

export default function SeriesConsentReminderBanner({
  series,
}: {
  series: SeriesConsentReminderBannerData
}) {
  const now = useServerNow()

  const { parentConsentCompletedAt: satLearnerParentConsentCompletedAt } =
    useSATBootcampLearnerOnboardingState()

  const lastReservationExpiredAt = series.viewer.selfReservationExpiresAt
  const isUserSelfReserved = series.viewer.isSelfReserved

  const linkParentConsent = url.getRequestParentConsentUrl()

  let expirationText = ''
  if (lastReservationExpiredAt != null) {
    expirationText = `Your spot expires ${toHumanReadableString(
      DateTime.fromISO(`${lastReservationExpiredAt}`).diff(now)
    )}.`
  }
  return isUserSelfReserved ? (
    <Alert variant="warning">
      <Text>
        {expirationText}{' '}
        {satLearnerParentConsentCompletedAt == null ? (
          <>
            Please remind your parent to{' '}
            <ShwLink href={linkParentConsent}>complete the consent form</ShwLink>!
          </>
        ) : null}
      </Text>
    </Alert>
  ) : null
}
